import { homeContent } from '@/mocks/content';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20 items-center">
          <div className="flex-1 order-2 lg:order-1">
            <div className="flex gap-4">
              <div className="w-[45%] aspect-[3/4] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Serene%20workspace%20with%20open%20laptop%20on%20light%20wood%20desk%20showing%20clean%20spreadsheet%20interface%20next%20to%20a%20ceramic%20mug%20and%20small%20plant%20warm%20morning%20sunlight%20streaming%20through%20window%20soft%20natural%20tones%20calm%20productive%20atmosphere%20editorial%20interior%20photography&width=400&height=533&seq=about-left-v2-unique&orientation=portrait"
                  alt="YOYBUY workspace"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-[55%] aspect-[3/4] rounded-2xl overflow-hidden mt-8">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20of%20carefully%20folded%20linen%20clothing%20pieces%20natural%20fabric%20swatches%20and%20a%20tablet%20device%20on%20light%20cream%20textured%20surface%20soft%20diffused%20overhead%20lighting%20editorial%20fashion%20composition%20warm%20neutral%20palette%20harmonious%20arrangement&width=533&height=711&seq=about-right-v2-unique&orientation=portrait"
                  alt="YOYBUY products flat lay"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2">
            <span className="inline-block text-xs font-semibold uppercase tracking-wider text-foreground-500 mb-4">
              {homeContent.aboutTag}
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight mb-6">
              {homeContent.aboutTitle}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              {homeContent.aboutDescription}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {homeContent.aboutDescription2}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}